import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  background: #fff;
  padding-top: 113px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    padding-left: 8px;
    padding-right: 8px;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 6px;
  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const Subtitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 37px;
  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  justify-content: center;
  width: 100%;
  max-width: 1300px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
`

export const ImageCol = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  @media (max-width: 600px) {
    min-width: unset;
    width: 100%;
    justify-content: center;
    margin-bottom: 16px;
  }
`

export const TextCol = styled.ul`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: disc inside;
  min-width: 320px;
  padding: 18px;
  align-items: flex-start;
  color: #21105d;
  /* bullets color for webkit browsers */
  & li {
    color: inherit;
  }
  & li::marker {
    color: #21105d;
  }
  @media (max-width: 600px) {
    min-width: unset;
    width: 100%;
    align-items: center;
    padding-left: 20px;
  }
`

export const ListItemText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  color: var(--blue6, #21105d);
  text-align: left;
  @media (max-width: 600px) {
    font-size: 12px;
    width: 100%;
    text-align: center;
  }
`

export const ListItemBold = styled.b`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: var(--blue6, #21105d);
`
